var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDbs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 52,
    height: 52,
    rx: 11,
    fill: "url(#pattern0)",
    stroke: "white",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_7_1832",
    transform: "scale(0.015625)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_7_1832",
    width: 64,
    height: 64,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAAXNSR0IArs4c6QAABPlJREFUeF7tmztMFFEUhs8UFlKRrHaAmChauaA0RCO+K+Oa+Ehs3EQsMPG5RixAxQeFJqKoiRZCgMZEbSB2+MJIKDS6a6VoIu7SKQmVFhZj/oVrxoHde+5jmVnWm1jg3rlzzncec+bcuQ75huu6m4hoNxHFiKja/3uR/p0kIvy76DjOuFcHR/zhum45EV0gopNFqiRX7JszIKZwQRbAjPIviKiWu0qRz4M3bHYcZ0oAuFEClvfb7KbjOKcc13UR51+L3KK64m8GgF4iiuuuUOTXdQHA+xKKfb+9xgHALXIrGok/LwB+Tv2k1OA7yiQzNJn+QROpNP2a+kX4fzEi1RGKLFtCFWuqqLK2imo2rqJI9RIj5TgXFwwAlHt+e4jGhj/S2PAnjiyz5lREK2nr8R0FhWEdgFD8+a2hfyysRcBzUcPB9bTzXMy6V1gF8OTyANlW3A9u5/lYFoStYQXA5LcfdHfPbZpIZWzJlXcd5IrE0xYr3mAMYLR/hB6dfmDV3TkUF5eXUfz+IaqNreVMzznHCABc/smlASMBTC82DQltAGFQXsAzgaAFIDnwju7tvWNqPKvXx7ubCE8K1aEMAAmvo7593mNephhyQtubduXEqAygdeUZmhyflMkTyO8onNreXlS6txKAMMV9Li1RIyAncAcbAFy/dUULd93A5iEUOj5fo7LyMpYMbAB9Td2EZ76tEVk2/fKDgfJ54oO9IkrFC1gAbFkfb3hwz4po1SwLiTfG0b4RGnul9/IkjKPiBSwAo/2vqa+pR9v4cMfmx0eppnE1aw3cD/nGJNlyvYAF4Mq6dpr4kGYJ75+kW7fD6zq3XdWGUNO4ihJPz0pllgIwcX9d5YXUpjVH5/c70mQoBWDi/rrVmddsaKh0brsmteRcE+L3m6ghnr86lAJ4mHiQ7eyoDiS8xDO5C3LWRSjodJW2HNtO+zsP5L2FFIDuzW1YX0iu6wXRWB0deXzMDIBu6cuJP471RZ2QWHqUO/3vPOSgji/5w0fqAc2LDinfuDJaSa2KNbnsJjqGQD1w43v+t9aCALAZ/wKMbije+52/fvkPQLYzhNjzbmDIXBW/c2KPs453TmAeoBN7ENxmEsyup/koNA4BtLtTg9g/VRtoW3Nrf87KgQHQLoSYtThH+UA9wKQUtukFgXkAEqBOEQKr6TYq5/KKwACYuJ94ItjYxgoUAHZ/0KDQHXgsohOk07cPvBAStXjbyhblesAPDE2KhoMbKLqrTvqe7r82UA+AMKZe4FcIPXxu5xYelEmltXafjesAITiSoQ0vUA0j0VXqO9yt1ROwBqAQXiCD4W2pBR4CQtgr9Re0XFGmrP93fz8xNABMG5UcEMgNrb6NTt2NGashIIQ3qQ5lAKA86gZsnnhHqAAUKh/kUh73Cx2AQkDI9+4QSgCAgK9F+g/3GBdJsi5yaAEAguk2lkz50IaAP6HpVIv7rh+grce3y3JjOHPAXFLDGwCC8y0Bdwe3aDzACwQgsKPzrGtozo8fVJQXCRfrTZ9y4g/ZDrG0Lc6/Ve6ZgJFJprO1PD6VR69Q5TseGzLkWmNeABRSAdO1AQAHphbKAUlVHkkAwEHCE6pXLpD5vQCAo7I4NFmKY7k4OFmKXjB9cBJmL8Gjs9jq2vL36KwHQvsCzwc4Itg16/C0N/hnjtICRDSAA5WFOsOII/Po6w84jvPSq+8fDh1L0ZIAarQAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDbs);
export default __webpack_public_path__ + "static/media/dbs.a95e9b9744df3b0ede9b0d7cff501ff2.svg";
export { ForwardRef as ReactComponent };